import React from 'react';
import { Image, Button } from 'react-bootstrap';
import { IMAGE_PATHS } from 'constants/imagePaths';
import useCommonStore, { setModalConfig } from 'store/common';
import useAuthStore from 'store/auth';
import { S3_URL } from 'constants';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const CreatePost: React.FC = () => {
	const { translate } = useTranslate();
	const { hideCommonModal }: any = useCommonStore((state) => state);
	const authUser: any = useAuthStore((state) => state.userInfo.user);

	const handleShow = () => {
		setModalConfig({
			visible: true,
			type: 'createNewPost',
			onClose: hideCommonModal,
			props: {
				size: 'lg',
			},
		});
	};

	return (
		<div className="create-post white-box bg-white">
			<h5 className="fw-bold mb-2">{translate('Social.createPost')}</h5>
			<div className="create-post-box d-flex gap-2 gap-md-3">
				<div className="post-profile-img rounded-circle">
					<Image
						src={
							authUser?.profilePicture ? `${S3_URL}${authUser?.profilePicture}` : IMAGE_PATHS.UserBG
						}
						className="h-100 w-100 object-fit-cover rounded-circle"
						loading="lazy"
					/>
				</div>
				<div className="create-post-form flex-1" onClick={() => handleShow()}>
					<div className="create-post-form-input">
						<p className="mb-0">{translate('Social.writeHere')}...</p>
					</div>
					<div className="d-flex flex-column flex-sm-row justify-content-between gap-2 gap-md-3">
						<div className="d-flex gap-2 gap-md-3">
							<Button className="filled-btn upload-file-btn rounded-pill">
								<Image src={IMAGE_PATHS.UploadImg} loading="lazy" />{' '}
								{translate('Social.uploadPhoto')}
							</Button>
							<Button className="filled-btn upload-file-btn rounded-pill">
								<Image src={IMAGE_PATHS.UploadVideo} loading="lazy" />{' '}
								{translate('Social.uploadVideo')}
							</Button>
						</div>
						<Button className="filled-btn rounded-pill">{translate('Social.create')}</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreatePost;
